import React, { useEffect, useState } from 'react';
import Header from './components/header';
import ContactSection from './components/contactSection';
import HomeSection from './components/homeSection';
import ProductsSection from './components/productsSection';
import ServicesSection from './components/servicesSection';
import TrustBadges from './components/trustMarkers';
import Footer from './components/footer';
import { Analytics } from '@vercel/analytics/react';

import onionImg from './assets/onionPowder.png';
import tomatoImg from './assets/tomatoPowder.png';
import gingerImg from './assets/gingerPowder.png';
import garlicImg from './assets/garlicPowder.png';
import amlaImg from './assets/amlaPowder.png';
import ashwagandhaImg from './assets/ashwagandhaPowder.png';
import moringaImg from './assets/moringaPowder.png';
import triphalaImg from './assets/triphalaPowder.png';
import paprikaImg from './assets/redPepper.jpeg';
import whitePepperImg from './assets/whitePepper.jpeg';
import blackPepperImg from './assets/blackPepper.jpeg';
import oreganoImg from './assets/oreganoPowder.jpeg';
import turmericImg from './assets/turmericPowder.jpeg';
import corianderImg from './assets/corianderPowder.jpeg';
import garamMasalaImg from './assets/garamMasala.jpeg';
import jeeraImg from './assets/cuminJeera.jpeg';
import redChilliImg from './assets/redChilli.png';
import jeeraPowderImg from './assets/jeeraPowder.jpg';
import almondImg from './assets/almond.jpeg';
import cashewImg from './assets/cashew.jpeg';
import foxnutImg from './assets/foxnut.jpeg';
import walnutImg from './assets/walnut.jpeg';
import pistachioImg from './assets/pista.jpeg';
import raisinImg from './assets/raisin.jpeg';

function App() {
  const [activeTab, setActiveTab] = useState('home');
  const instaHandle = 'https://www.instagram.com/daughters_enterprise.powder/';

  useEffect(() => {
    window.scrollTo({ top: 10, left: 0, behavior: 'auto' });
  }, [activeTab]);

  const products = [
    {
      name: 'Onion Powder',
      category: 'Spices',
      image: onionImg,
      benefits: [
        'Adds rich onion flavor without peeling or chopping.',
        'Perfect for soups, curries, marinades, and snacks.',
        'Long shelf life and easy storage.',
        'Consistent taste in every dish.',
      ],
      price: 155,
      originalPrice: 210,
      links: {
        amazon: 'https://www.amazon.in/dp/B0GG7XZ915?th=1',
        flipkart: 'https://www.flipkart.com/product/p/itme?pid=SCMHJFHMAVX6TSV9',
        instagram: instaHandle,
      },
    },
    {
      name: 'Tomato Powder',
      category: 'Spices',
      image: tomatoImg,
      benefits: [
        'Natural tangy tomato flavor all year round.',
        'Ideal for gravies, soups, sauces, and seasoning blends.',
        'No spoilage compared to fresh tomatoes.',
        'Easy to use and mess-free.',
      ],
      price: 192,
      originalPrice: 249,
      links: {
        amazon: 'https://www.amazon.in/dp/B0GGS15G11?th=1',
        flipkart: 'https://www.flipkart.com/product/p/itme?pid=SCMHJGQKCNW8NVN3',
        instagram: instaHandle,
      },
    },
    {
      name: 'Ginger Powder',
      category: 'Spices',
      image: gingerImg,
      benefits: [
        'Strong, aromatic ginger flavor.',
        'Perfect for teas, curries, baked goods, and spice mixes.',
        'Convenient alternative to fresh ginger.',
        'Adds warmth and depth to recipes.',
      ],
      price: 232,
      originalPrice: 299,
      links: {
        amazon: 'https://www.amazon.in/dp/B0GGHYCJ6Y?th=1',
        flipkart: 'https://www.flipkart.com/product/p/itme?pid=SCMHJFMFCFZKRZFZ',
        instagram: instaHandle,
      },
    },
    {
      name: 'Garlic Powder',
      category: 'Spices',
      image: garlicImg,
      benefits: [
        'Rich garlic taste without peeling or crushing.',
        'Ideal for marinades, seasoning blends, and snacks.',
        'Even flavor distribution in dishes.',
        'Long-lasting and easy to store.',
      ],
      price: 125,
      originalPrice: 199,
      links: {
        amazon: 'https://www.amazon.in/dp/B0GG72Z852?th=1',
        flipkart: 'https://www.flipkart.com/product/p/itme?pid=SCMHJEJDAZNYSMTH',
        instagram: instaHandle,
      },
    },
    {
      name: 'White Pepper Powder',
      category: 'Spices',
      image: whitePepperImg,
      benefits: [
        'Mild heat with a smooth, earthy flavor.',
        'Ideal for soups, sauces, and light-colored dishes.',
        'Enhances taste without overpowering.',
        'Used widely in continental cooking.',
      ],
      price: 1299,
      originalPrice: 1349,
      links: {
        amazon: 'https://www.amazon.in/dp/B0GHGVN1K1?th=1',
        flipkart: null,
        instagram: instaHandle,
      },
    },
    {
      name: 'Black Pepper Powder',
      category: 'Spices',
      image: blackPepperImg,
      benefits: [
        'Bold aroma and strong pungency.',
        'Enhances flavor of everyday meals.',
        'Essential spice for Indian and global cuisines.',
        'Freshly ground for maximum taste.',
      ],
      price: 679,
      originalPrice: 739,
      links: {
        amazon: 'https://www.amazon.in/dp/B0GHH2LH4S?th=1',
        flipkart: null,
        instagram: instaHandle,
      },
    },
    {
      name: 'Paprika Powder',
      category: 'Spices',
      image: paprikaImg,
      benefits: [
        'Mild sweetness with vibrant red color.',
        'Perfect for seasoning, garnishing, and marinades.',
        'Adds visual appeal to dishes.',
        'Widely used in continental and fusion foods.',
      ],
      price: 1199,
      originalPrice: 1250,
      links: {
        amazon: 'https://www.amazon.in/dp/B0GHJT6MWN?th=1',
        flipkart: null,
        instagram: instaHandle,
      },
    },
    {
      name: 'Oregano Powder',
      category: 'Spices',
      image: oreganoImg,
      benefits: [
        'Classic Italian herb aroma.',
        'Perfect for pizza, pasta, and breads.',
        'Enhances taste of continental dishes.',
        'Highly aromatic and flavorful.',
      ],
      price: 229,
      originalPrice: 299,
      links: {
        amazon: 'https://www.amazon.in/dp/B0GHGYRNV4?th=1',
        flipkart: null,
        instagram: instaHandle,
      },
    },
    {
      name: 'Turmeric Powder',
      category: 'Spices',
      image: turmericImg,
      benefits: [
        'Contains natural curcumin with anti-inflammatory properties.',
        'Traditionally used to support immunity and digestion.',
        'Commonly used for skin care and home remedies.',
        'Pure, fresh, and finely ground for strong aroma and color.',
      ],
      price: 229,
      originalPrice: 279,
      links: {
        amazon: null,
        flipkart: null,
        instagram: instaHandle,
      },
    },
    {
      name: 'Garam Masala',
      category: 'Spices',
      image: garamMasalaImg,
      benefits: [
        'Authentic blend of handpicked whole spices.',
        'Enhances taste, aroma, and warmth of everyday dishes.',
        'Prepared using traditional grinding methods.',
        'Free from artificial colors and preservatives.',
      ],
      price: 799,
      originalPrice: 899,
      links: {
        amazon: null,
        flipkart: null,
        instagram: instaHandle,
      },
    },
    {
      name: 'Red Chilli Powder',
      category: 'Spices',
      image: redChilliImg,
      benefits: [
        'Made from premium quality dried red chillies.',
        'Adds rich color and balanced heat to dishes.',
        'Finely ground for smooth texture and even mixing.',
        'No added colors or adulterants.',
      ],
      price: 285,
      originalPrice: 320,
      links: {
        amazon: null,
        flipkart: null,
        instagram: instaHandle,
      },
    },
    {
      name: 'Jeera Powder',
      category: 'Spices',
      image: jeeraPowderImg,
      benefits: [
        'Known to support digestion and gut health.',
        'Strong aroma and bold flavor from fresh cumin seeds.',
        'Commonly used in Indian cooking and tempering.',
        'Carefully cleaned and hygienically packed.',
      ],
      price: 215,
      originalPrice: 279,
      links: {
        amazon: null,
        flipkart: null,
        instagram: instaHandle,
      },
    },
    {
      name: 'Coriander Powder',
      category: 'Spices',
      image: corianderImg,
      benefits: [
        'Prepared from premium quality dried coriander seeds.',
        'Adds mild sweetness and earthy flavor to curries.',
        'Finely ground for consistent taste in every dish.',
        'Fresh, aromatic, and free from additives.',
      ],
      price: 155,
      originalPrice: 249,
      links: {
        amazon: null,
        flipkart: null,
        instagram: instaHandle,
      },
    },
    {
      name: 'Jeera Whole',
      category: 'Spices',
      image: jeeraImg,
      benefits: [
        'Known to support digestion and gut health.',
        'Strong aroma and bold flavor from fresh cumin seeds.',
        'Commonly used in Indian cooking and tempering.',
        'Carefully cleaned and hygienically packed.',
      ],
      price: 245,
      originalPrice: 299,
      links: {
        amazon: null,
        flipkart: null,
        instagram: instaHandle,
      },
    },
    {
      name: 'Amla Powder',
      category: 'Herbal Powders',
      image: amlaImg,
      benefits: [
        'Rich source of natural vitamin C.',
        'Traditionally used for hair and skin care.',
        'Can be consumed or used externally.',
        'Pure and finely ground.',
      ],
      price: 799,
      originalPrice: 849,
      links: {
        amazon: 'https://www.amazon.in/dp/B0GGS6FF53?th=1',
        flipkart: null,
        instagram: instaHandle,
      },
    },
    {
      name: 'Triphala Powder',
      category: 'Herbal Powders',
      image: triphalaImg,
      benefits: [
        'Traditional Ayurvedic herbal blend.',
        'Made from three dried fruits.',
        'Commonly used in wellness routines.',
        'Finely ground and easy to use.',
      ],
      price: 159,
      originalPrice: 229,
      links: {
        amazon: 'https://www.amazon.in/dp/B0GH1RZF52',
        flipkart: null,
        instagram: instaHandle,
      },
    },
    {
      name: 'Moringa Powder',
      category: 'Herbal Powders',
      image: moringaImg,
      benefits: [
        'Made from dried moringa leaves.',
        'Rich green color and earthy taste.',
        'Used in smoothies, teas, and meals.',
        'Naturally processed and pure.',
      ],
      price: 185,
      originalPrice: 219,
      links: {
        amazon: 'https://www.amazon.in/dp/B0GGVCSRJS?th=1',
        flipkart: 'https://www.flipkart.com/product/p/itme?pid=SCMHJH7ENKJDJHPC',
        instagram: instaHandle,
      },
    },
    {
      name: 'Ashwagandha Powder',
      category: 'Herbal Powders',
      image: ashwagandhaImg,
      benefits: [
        'Traditional Ayurvedic herb.',
        'Commonly used in daily wellness routines.',
        'Finely ground for easy mixing.',
        'Pure and naturally processed.',
      ],
      price: 719,
      originalPrice: 799,
      links: {
        amazon: 'https://www.amazon.in/dp/B0GH89J4ZY?th=1',
        flipkart: null,
        instagram: instaHandle,
      },
    },
    {
      name: 'Almond',
      category: 'Dry Fruits',
      image: almondImg,
      benefits: [
        'Premium quality almonds packed with nutrients and natural goodness',
        'Rich in protein, fiber, and healthy fats, they support heart health, boost energy, and make a perfect daily snack or addition to sweets and dishes',
      ],
      price: 1199,
      originalPrice: 1250,
      links: {
        amazon: null,
        flipkart: null,
        instagram: instaHandle,
      },
    },
    {
      name: 'Cashew',
      category: 'Dry Fruits',
      image: cashewImg,
      benefits: [
        'Premium quality cashews with a rich, creamy texture and naturally sweet taste',
        'High in essential minerals like magnesium and zinc, perfect for snacking, cooking, and desserts',
      ],
      price: 949,
      originalPrice: 1000,
      links: {
        amazon: null,
        flipkart: null,
        instagram: instaHandle,
      },
    },
    {
      name: 'Fox Nut (Makhana)',
      category: 'Dry Fruits',
      image: foxnutImg,
      benefits: [
        'Light and crunchy fox nuts that make a healthy alternative to fried snacks',
        'Low in calories and high in protein, ideal for roasting and guilt-free munching',
      ],
      price: 1449,
      originalPrice: 1600,
      links: {
        amazon: null,
        flipkart: null,
        instagram: instaHandle,
      },
    },
    {
      name: 'Walnut',
      category: 'Dry Fruits',
      image: walnutImg,
      benefits: [
        'High-quality walnuts known for their rich flavor and crunchy texture',
        'Loaded with omega-3 fatty acids and antioxidants that support brain and heart health',
      ],
      price: 1799,
      originalPrice: 1900,
      links: {
        amazon: null,
        flipkart: null,
        instagram: instaHandle,
      },
    },
    {
      name: 'Pistachio',
      category: 'Dry Fruits',
      image: pistachioImg,
      benefits: [
        'Flavorful pistachios with a perfect balance of taste and nutrition',
        'Rich in protein and fiber, great for snacking and garnishing sweets and desserts',
      ],
      price: 1309,
      originalPrice: 1360,
      links: {
        amazon: null,
        flipkart: null,
        instagram: instaHandle,
      },
    },
    {
      name: 'Raisin',
      category: 'Dry Fruits',
      image: raisinImg,
      benefits: [
        'Naturally sweet and chewy raisins made from premium dried grapes',
        'Rich in iron and antioxidants, great for boosting energy and improving digestion',
      ],
      price: 599,
      originalPrice: 650,
      links: {
        amazon: null,
        flipkart: null,
        instagram: instaHandle,
      },
    },
  ];

  const productsWithUnits = products.map((product) => ({
    ...product,
    unit: product.category === 'Dry Fruits' ? '1kg' : '1kg',
  }));

  const renderTabContent = () => {
    if (activeTab === 'products') {
      return (
        <ProductsSection
          products={productsWithUnits}
          onContactUs={() => setActiveTab('contact')}
        />
      );
    }

    if (activeTab === 'services') {
      return <ServicesSection />;
    }

    if (activeTab === 'contact') {
      return <ContactSection />;
    }

    return  <HomeSection 
              onExploreProducts={() => setActiveTab('products')} 
              onContactUs={() => setActiveTab('contact')} 
            />;
  };

  return (
    <div className="app">
      <Header />

      <nav className="section-tabs" aria-label="Primary">
        <button
          className={`section-tab ${activeTab === 'home' ? 'active' : ''}`}
          onClick={() => setActiveTab('home')}
        >Home</button>
        <button
          className={`section-tab ${activeTab === 'products' ? 'active' : ''}`}
          onClick={() => setActiveTab('products')}
        >Products</button>
        <button
          className={`section-tab ${activeTab === 'services' ? 'active' : ''}`}
          onClick={() => setActiveTab('services')}
        >Services</button>
        <button
          className={`section-tab ${activeTab === 'contact' ? 'active' : ''}`}
          onClick={() => setActiveTab('contact')}
        >Contact Us</button>
      </nav>

      {renderTabContent()}

      <TrustBadges />
      <Footer />
      <Analytics />
    </div>
  );
}
export default App;
